var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es507.js.map
